module.exports = __webpack_public_path__ + "img/rooms_available.3d8a3525.svg";